module.exports = __webpack_public_path__ + "img/living-memories.d28639a1.png";